export const BEFORE_SILENT_SIGN_IN_ATTEMPT = "BEFORE_SILENT_SIGN_IN_ATTEMPT";
export const NO_SESSION = "NO_SESSION";
export const SESSION_EXPIRED = "SESSION_EXPIRED";
export const SIGNED_IN = "SIGNED_IN";
